import { QuestionnaireItem } from "@medplum/fhirtypes";

/**
 * FHIR `Questionnaire.item.type` codes, with the same members as `QuestionnaireItemType` from
 * `@medplum/react`. Code shared with bots imports this copy, so bot bundles stay free of
 * `@medplum/react` and its browser globals.
 */
export const QuestionnaireItemType = {
  group: "group",
  display: "display",
  question: "question",
  boolean: "boolean",
  decimal: "decimal",
  integer: "integer",
  date: "date",
  dateTime: "dateTime",
  time: "time",
  string: "string",
  text: "text",
  url: "url",
  choice: "choice",
  openChoice: "open-choice",
  attachment: "attachment",
  reference: "reference",
  quantity: "quantity",
} as const satisfies Record<string, QuestionnaireItem["type"]>;

export type QuestionnaireItemType = QuestionnaireItem["type"];
